import type { Point, SpatialRectangle } from "#public"

import { Max, Min } from "../math/Math"

/** The smallest box holding every one of `points`: with two, the box with
 * them at opposite corners, whichever way round. */
export const BoundingBox = <T extends number>(...points: Point<T>[]): SpatialRectangle<T> => {
  const xs = points.map(p => p.x)
  const ys = points.map(p => p.y)
  const x = Min(...xs)
  const y = Min(...ys)
  return { x, y, width: (Max(...xs) - x) as T, height: (Max(...ys) - y) as T }
}
